import { getCookie, getUrlParams } from '@ugc-utils/utils';

export function getPreference() {
  const cookiePreference = getUrlParams(getCookie('ih-preference')) as {
    country: string;
    language: string;
    currency: string;
  };

  const cookiePref1 = getUrlParams(getCookie('iher-pref1')) as {
    lan: string;
    scurcode: string;
    sccode: string;
  };

  return {
    language: cookiePref1.lan || cookiePreference.language || 'en-US',
    country: cookiePref1.sccode || cookiePreference.country || 'US',
    currency: cookiePref1.scurcode || cookiePreference.currency || 'USD',
  };
}
